import { View, Text, Image, StyleSheet } from "@react-pdf/renderer";

import dotRoomIcon from "assets/img/report-dot-room.png";
import dotEnergyIcon from "assets/img/report-dot-energy.png";
import dotWaterIcon from "assets/img/report-dot-water.png";
import dotWaterLeakageIcon from "assets/img/report-dot-water-leakage.png";
import dotTemperatureIcon from "assets/img/report-dot-temperature.png";
import dotHumidityIcon from "assets/img/report-dot-humidity.png";
import dotCO2Icon from "assets/img/report-dot-co2.png";
import dotPressureIcon from "assets/img/report-dot-pressure.png";
import dotTVOCIcon from "assets/img/report-dot-tvoc.png";
import dotPM1Icon from "assets/img/report-dot-pm1.png";
import dotPM25Icon from "assets/img/report-dot-pm25.png";
import dotPM10Icon from "assets/img/report-dot-pm10.png";

import { REPORT_SENSOR_REGISTRY } from "constant/report";
import { ReportItemType } from "types/Reports";

const overallBulletTextStyles = StyleSheet.create({
    overallCardNumberItemContainer: {
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 10,
    },
    overallCardNumberItem: {
        position: 'relative',
        fontFamily: 'Roboto',
        fontSize: 12,
        fontWeight: 400,
        color: '#333333',
        marginLeft: 6,
    },
    overallCardNumberItemDot: {
        position: 'relative',
        width: 6,
        height: 6,
    },
});

type ReportPDFOverallBulletTextProps = {
    itemType: ReportItemType;
};

const ReportPDFOverallBulletText = ({
    itemType,
}: ReportPDFOverallBulletTextProps) => {
    const REPORT_SENSOR_DOT = {
        room: dotRoomIcon,
        energy: dotEnergyIcon,
        water: dotWaterIcon,
        waterLeakage: dotWaterLeakageIcon,
        temperature: dotTemperatureIcon,
        humidity: dotHumidityIcon,
        co2: dotCO2Icon,
        pressure: dotPressureIcon,
        tvoc: dotTVOCIcon,
        pm1: dotPM1Icon,
        'pm2.5': dotPM25Icon,
        pm10: dotPM10Icon,
    };

    const dotIconSrc = REPORT_SENSOR_DOT[itemType];
    const dotText = REPORT_SENSOR_REGISTRY[itemType].bullet;

    return (
        <View style={overallBulletTextStyles.overallCardNumberItemContainer}>
            <Image style={overallBulletTextStyles.overallCardNumberItemDot} src={dotIconSrc} />
            <Text style={overallBulletTextStyles.overallCardNumberItem}>
                {dotText}
            </Text>
        </View>
    );
};

export default ReportPDFOverallBulletText;
